import React from 'react';

const ArticleCard = ({ article, onClick, formatDate, truncateText, onCardClick }) => {
  // Handle image URL - from API or fallback
  const imageUrl = article.banner_image_url
    || (article.images && article.images[0])
    || 'https://via.placeholder.com/400x250?text=No+Image';

  const title = article.title;
  const summary = article.summary;
  const sourceName = article.source_name;

  const handleClick = async () => {
    // Track click in backend
    if (onCardClick) {
      await onCardClick(article.id);
    }
    
    // Open modal
    onClick(article);
  };

  return (
    <div className="article-card" onClick={handleClick}>
      <div className="card-image">
        <img 
          src={imageUrl} 
          alt={title}
          onError={(e) => e.target.src = 'https://via.placeholder.com/400x250?text=Image+Not+Found'} 
        />
        <span className="card-source-badge">{sourceName}</span>
      </div>
      <div className="card-content">
        <div className="card-meta">
          <span className="card-date">{formatDate(article.scraped_at)}</span>
          {article.reading_time && (
            <span className="card-reading-time">{article.reading_time} min read</span>
          )}
        </div>
        <h3 className="card-title">{title}</h3>
        <p className="card-summary">{truncateText(summary, 120)}</p>
        <div className="card-footer">
          <span className="read-more">Read Summary →</span>
          {article.click_count > 0 && (
            <span className="click-count">{article.click_count} views</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ArticleCard;